
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_1b38z_5",
  "grid": "awsui_grid_vvxn7_1b38z_15",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_1b38z_20",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_1b38z_23",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_1b38z_30",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_1b38z_33",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_1b38z_33",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_1b38z_36",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_1b38z_39",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_1b38z_45",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_1b38z_51",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_1b38z_64",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_1b38z_97"
};
  